import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { UserCog, Plus, Trash2, ShieldCheck, Wallet } from "lucide-react";

const EMPTY = { name:"", email:"", password:"", role:"admin_admin" };
const LABELS = {
  admin_admin: { title: "Admin Administrativo", icon: <ShieldCheck size={12}/>, desc: "Gerencia agenda, clientes, planos, especialidades, equipe e parcerias. NÃO acessa Financeiro." },
  admin_caixa: { title: "Admin Caixa da Loja", icon: <Wallet size={12}/>, desc: "Acessa apenas Financeiro e Materiais (estoque)." },
};

export default function SubAdminsTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);

  const load = () => { api.get("/admin/sub-admins").then(r=>setItems(r.data)); };
  useEffect(load, []);

  const save = async () => {
    if (!form.name || !form.email || !form.password) return toast.error("Preencha todos os campos");
    try {
      await api.post("/admin/sub-admins", form);
      toast.success("Sub-admin criado");
      setForm(EMPTY); load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Falha ao criar");
    }
  };
  const del = async (uid) => { if (!window.confirm("Remover este acesso?")) return; await api.delete(`/admin/sub-admins/${uid}`); load(); };

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 card-arya overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[var(--cream-100)] text-left text-xs tracking-widest font-display">
            <tr><th className="p-4">NOME</th><th className="p-4">EMAIL</th><th className="p-4">PERFIL</th><th className="p-4"></th></tr>
          </thead>
          <tbody className="divide-y divide-[var(--line)]">
            {items.map(u => (
              <tr key={u.user_id} data-testid={`sub-${u.user_id}`}>
                <td className="p-4 font-display font-semibold">{u.name}</td>
                <td className="p-4">{u.email}</td>
                <td className="p-4">
                  <span className="tag-sun inline-flex items-center gap-1">{LABELS[u.role]?.icon} {LABELS[u.role]?.title || u.role}</span>
                </td>
                <td className="p-4"><button onClick={()=>del(u.user_id)} className="p-1 text-[color:var(--danger)]" data-testid={`del-sub-${u.user_id}`}><Trash2 size={16}/></button></td>
              </tr>
            ))}
            {items.length===0 && <tr><td colSpan="4" className="p-8 text-center text-[color:var(--ink-500)]">Nenhum sub-admin cadastrado.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="card-arya p-6 h-fit">
        <h3 className="font-serif text-xl mb-3 flex items-center gap-2"><UserCog size={16}/> Novo sub-admin</h3>
        <div className="space-y-2">
          <input placeholder="Nome" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="sub-name"/>
          <input type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="sub-email"/>
          <input type="password" placeholder="Senha inicial" value={form.password} onChange={e=>setForm({...form, password:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="sub-password"/>
          <div className="grid grid-cols-1 gap-2">
            {Object.entries(LABELS).map(([role, cfg]) => (
              <button key={role} onClick={()=>setForm({...form, role})} aria-pressed={form.role===role}
                      data-testid={`sub-role-${role}`}
                      className={`text-left rounded-xl border p-3 transition ${form.role===role ? 'border-[color:var(--sun-600)] bg-[rgba(233,204,133,.12)]' : 'border-[var(--line)]'}`}>
                <div className="font-display font-semibold inline-flex items-center gap-1">{cfg.icon} {cfg.title}</div>
                <p className="text-xs text-[color:var(--ink-500)] mt-1">{cfg.desc}</p>
              </button>
            ))}
          </div>
          <button onClick={save} className="btn-gold w-full inline-flex items-center justify-center gap-1" data-testid="btn-save-sub"><Plus size={14}/> Criar acesso</button>
        </div>
      </div>
    </div>
  );
}
